// Assistants store a full sourceUrl but the UI almost always wants the bare
// host. Falls back to stripping the scheme so a malformed value still renders
// as something readable rather than blank.
export const hostOf = (url) => {
  if (!url) return "";

  try {
    return new URL(url).hostname;
  } catch {
    return url.replace(/^https?:\/\//i, "");
  }
};
